// schemas/subCategorySchemas.js

export const subCategorySchemas = {
  "/product-category/epoxy-resin/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/epoxy-resin/#collectionpage",
    url: "https://hutaib.org/product-category/epoxy-resin/",
    name: "Epoxy Resin",
    headline: "Epoxy Resin in Pakistan for Construction and Coatings",
    description:
      "Industrial epoxy resin products in Pakistan for flooring, coatings, adhesives, laminates, and construction applications. Hutaib Industrial Solutions supplies durable epoxy resin systems and curing agents for commercial and industrial use.",
    keywords: [
      "Epoxy Flooring",
      "Epoxy Floor",
      "Epoxy Resin",
      "Epoxy Curing Agents",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Epoxy Resin Products",
      numberOfItems: 2,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/epoxy-resin-epon-1001-x-75",
          item: {
            "@type": "Product",
            name: "EPON™ Resin 1001-X-75",
            url: "https://hutaib.org/product/epoxy-resin-epon-1001-x-75",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/high-performance-epoxy-epon-828",
          item: {
            "@type": "Product",
            name: "EPON™ Resin 828",
            url: "https://hutaib.org/product/high-performance-epoxy-epon-828",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/admixture/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/admixture/#collectionpage",
    url: "https://hutaib.org/product-category/admixture",
    name: "Admixture",
    headline: "Concrete Admixtures in Pakistan for Durable Construction",
    description:
      "Concrete admixture products in Pakistan for workability, water reduction, setting control, and strength development in construction applications. Hutaib Industrial Solutions supplies chemical admixtures for concrete production, precast structures, flooring, and infrastructure projects.",
    keywords: [
      "Concrete Admixture",
      "Admixture in Construction",
      "Admixtures for Concrete",
      "Chemical Admixtures",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Admixture Products",
      numberOfItems: 4,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/lignin-based-superplasticizer-sodium-lignosulphonate",
          item: {
            "@type": "Product",
            name: "Sodium Lignosulphonate",
            url: "https://hutaib.org/product/lignin-based-superplasticizer-sodium-lignosulphonate",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
          item: {
            "@type": "Product",
            name: "Sodium Gluconate",
            url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/naphthalene-based-superplasticizer",
          item: {
            "@type": "Product",
            name: "Sodium Naphthalene Sulfonate Formaldehyde",
            url: "https://hutaib.org/product/naphthalene-based-superplasticizer",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/his-pce-1021",
          item: {
            "@type": "Product",
            name: "HIS PCE 1021",
            url: "https://hutaib.org/product/his-pce-1021",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/rdp-grades/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/rdp-grades/#collectionpage",
    url: "https://hutaib.org/product-category/rdp-grades",
    name: "RDP Grades",
    headline: "RDP Grades Supplier in Pakistan for Construction Materials",
    description:
      "Redispersible polymer powder (RDP) products in Pakistan for construction applications such as tile adhesives, wall putty, skim coats, waterproof mortars, and repair systems. Hutaib Industrial Solutions provides RDP grades used for improving adhesion, flexibility, and mechanical performance in cement based formulations.",
    keywords: [
      "Construction Redispersible Polymer Powder",
      "RDP for Construction",
      "Redispersible Polymer Powder",
      "RDP chemical",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "RDP Grades Products",
      numberOfItems: 5,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/his-rdp-313n",
          item: {
            "@type": "Product",
            name: "HIS RDP 313N",
            url: "https://hutaib.org/product/his-rdp-313n",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/his-rdp-558f",
          item: {
            "@type": "Product",
            name: "HIS RDP 558F",
            url: "https://hutaib.org/product/his-rdp-558f",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/his-rdp-558h",
          item: {
            "@type": "Product",
            name: "HIS RDP 558H",
            url: "https://hutaib.org/product/his-rdp-558h",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/his-rdp-se-200",
          item: {
            "@type": "Product",
            name: "HIS RDP SE-200",
            url: "https://hutaib.org/product/his-rdp-se-200",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/his-rdp-sl-100",
          item: {
            "@type": "Product",
            name: "HIS RDP SL-100",
            url: "https://hutaib.org/product/his-rdp-sl-100",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/sbr-grades/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/sbr-grades/#collectionpage",
    url: "https://hutaib.org/product-category/sbr-grades",
    name: "SBR Grades",
    headline: "SBR Grades Supplier in Pakistan for Concrete and Mortar",
    description:
      "Styrene butadiene rubber (SBR) chemical grades in Pakistan for concrete modification, mortar systems, waterproofing layers, repair mortars, and bonding applications. Hutaib Industrial Solutions supplies SBR based emulsions used in construction materials to improve adhesion, flexibility, and resistance properties.",
    keywords: [
      "SBR Chemical",
      "Styrene Butadiene Rubber",
      "Chemical Grade SBR",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "SBR Grades Products",
      numberOfItems: 4,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/bos-sbr-9950",
          item: {
            "@type": "Product",
            name: "BOS SBR-9950",
            url: "https://hutaib.org/product/bos-sbr-9950",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/his-sbr-7303",
          item: {
            "@type": "Product",
            name: "HIS SBR 7303",
            url: "https://hutaib.org/product/his-sbr-7303",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/his-sbr-8860",
          item: {
            "@type": "Product",
            name: "HIS SBR 8860",
            url: "https://hutaib.org/product/his-sbr-8860",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/lipaton-sb-5843",
          item: {
            "@type": "Product",
            name: "LIPATON™ SB 5843",
            url: "https://hutaib.org/product/lipaton-sb-5843",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/styrene-acrylic/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/styrene-acrylic/#collectionpage",
    url: "https://hutaib.org/product-category/styrene-acrylic",
    name: "Styrene Acrylic",
    headline: "Styrene Acrylic Supplier in Pakistan for Construction",
    description:
      "Styrene acrylic emulsions in Pakistan for construction coatings, waterproofing systems, adhesives, cement modification, and protective surface layers. Hutaib Industrial Solutions supplies styrene acrylic polymer products used in building materials to support adhesion, durability, and water resistance.",
    keywords: [
      "Styrene Acrylic",
      "Styrene Acrylic Emulsions",
      "Styrene-Acrylic Polymer Emulsion",
      "Acrylonitrile Styrene Acrylate",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Styrene Acrylic Products",
      numberOfItems: 3,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/revacryl-ae-2091-ja",
          item: {
            "@type": "Product",
            name: "REVACRYL™ AE 2091 JA",
            url: "https://hutaib.org/product/revacryl-ae-2091-ja",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/revacryl-ae-3020",
          item: {
            "@type": "Product",
            name: "REVACRYL™ AE 3020",
            url: "https://hutaib.org/product/revacryl-ae-3020",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/water-guard-3020",
          item: {
            "@type": "Product",
            name: "Water Guard 3020",
            url: "https://hutaib.org/product/water-guard-3020",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/momentive-amino-functional-fluid/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/momentive-amino-functional-fluid/#collectionpage",
    url: "https://hutaib.org/product-category/momentive-amino-functional-fluid",
    name: "Amino Functional Fluids",
    headline: "Amino Silicone Fluids for Soft, Durable Textiles",
    description:
      "Amino functional silicone fluids in Pakistan used in textile finishing, fabric softening, coating systems, and surface treatment applications. Hutaib Industrial Solutions supplies amine functional silicone oils and polymers used to improve softness, smoothness, and handling properties in textile processing.",
    keywords: [
      "Amine Functional Silicone Fluid",
      "Amine Functional Polymers",
      "Amine Functional Fluid",
      "Amino Silicone Fluids",
      "Amino Functional Silicone Fluid",
      "Amino Silicone Oil",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Amino Functional Fluids Products",
      numberOfItems: 10,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/xiameter-ofx-8040-fluid",
          item: {
            "@type": "Product",
            name: "XIAMETER™ OFX-8040 Fluid",
            url: "https://hutaib.org/product/xiameter-ofx-8040-fluid",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/xiameter-ofx-8468-fluid",
          item: {
            "@type": "Product",
            name: "XIAMETER™ OFX-8468 Fluid",
            url: "https://hutaib.org/product/xiameter-ofx-8468-fluid",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/bluesil-supersoft-c910-a2",
          item: {
            "@type": "Product",
            name: "BLUESIL™ SUPERSOFT C910 A2",
            url: "https://hutaib.org/product/bluesil-supersoft-c910-a2",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/ge-01530",
          item: {
            "@type": "Product",
            name: "GE 01530",
            url: "https://hutaib.org/product/ge-01530",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/bluesil-extrasoft-c845-a2",
          item: {
            "@type": "Product",
            name: "BLUESIL™ EXTRASOFT C845 A2",
            url: "https://hutaib.org/product/bluesil-extrasoft-c845-a2",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/water-repellent-coating-sf-3830",
          item: {
            "@type": "Product",
            name: "SF-3830",
            url: "https://hutaib.org/product/water-repellent-coating-sf-3830",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          url: "https://hutaib.org/product/performance-additive-tsf-4703",
          item: {
            "@type": "Product",
            name: "TSF-4703",
            url: "https://hutaib.org/product/performance-additive-tsf-4703",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          url: "https://hutaib.org/product/specialty-coating-agent-tsf-4708",
          item: {
            "@type": "Product",
            name: "TSF-4708",
            url: "https://hutaib.org/product/specialty-coating-agent-tsf-4708",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 9,
          url: "https://hutaib.org/product/high-solids-paint-sf-4901",
          item: {
            "@type": "Product",
            name: "SF-4901",
            url: "https://hutaib.org/product/high-solids-paint-sf-4901",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 10,
          url: "https://hutaib.org/product/fabric-softener-magnasoft-plus",
          item: {
            "@type": "Product",
            name: "Magnasoft Plus",
            url: "https://hutaib.org/product/fabric-softener-magnasoft-plus",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/silicone-oil/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/silicone-oil/#collectionpage",
    url: "https://hutaib.org/product-category/silicone-oil",
    name: "Block Silicone Fluids",
    headline: "Block Silicone Fluids for Soft & Durable Fabrics",
    description:
      "Silicone oil based textile softeners in Pakistan used for fabric softness, smooth handling, and finishing performance in textile processing. Hutaib Industrial Solutions supplies hydrophilic and hydrophobic block silicone fluids for cotton, polyester, and blended fabrics in industrial textile applications.",
    keywords: [
      "Silicone Fluid Emulsion",
      "Silicone Oil for Textile",
      "Silicone Oil",
      "Textile Silicone Oil",
      "Textile Silicone Fluid",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Block Silicone Fluids Products",
      numberOfItems: 6,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/ressisoft-s116",
          item: {
            "@type": "Product",
            name: "RessiSoft S116 (Hydrophilic Block Silicone Fluids)",
            url: "https://hutaib.org/product/ressisoft-s116",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/ressisoft-pearl",
          item: {
            "@type": "Product",
            name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
            url: "https://hutaib.org/product/ressisoft-pearl",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/advanced-textile-softener-ressisoft-832",
          item: {
            "@type": "Product",
            name: "Ressisoft 832 (Hydrophobic Block Silicone Softener)",
            url: "https://hutaib.org/product/advanced-textile-softener-ressisoft-832",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
          item: {
            "@type": "Product",
            name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
            url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/ressisoft-eco",
          item: {
            "@type": "Product",
            name: "RessiSoft ECO (Hydrophobic Block Silicone Fluids)",
            url: "https://hutaib.org/product/ressisoft-eco",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/ressisoft-bostex",
          item: {
            "@type": "Product",
            name: "RessiSoft BosTex (Hydrophobic Block Silicone Fluids)",
            url: "https://hutaib.org/product/ressisoft-bostex",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/hydrophilic-oil/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/hydrophilic-oil/#collectionpage",
    url: "https://hutaib.org/product-category/hydrophilic-oil",
    name: "Hydrophilic",
    headline: "Hydrophilic Silicone Softeners for Textiles",
    description:
      "Hydrophilic silicone softeners in Pakistan used for textile finishing, fabric conditioning, and surface treatment applications. Hutaib Industrial Solutions supplies silicone based emulsions designed for improved water affinity, softness, and handling in textile processing.",
    keywords: [
      "Hydrophilic Silicone Softener for Textiles",
      "Silicone Polymer Hydrophilic Silicone Softener",
      "Hydrophilic Silicone Softener",
      "Fabric Hydrophilic Silicone Softener",
      "Textiles Hydrophilic Silicone Softener",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Hydrophilic Products",
      numberOfItems: 6,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/silicone-based-coating-magnasoft-silq",
          item: {
            "@type": "Product",
            name: "MagnaSoft SilQ",
            url: "https://hutaib.org/product/silicone-based-coating-magnasoft-silq",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex",
          item: {
            "@type": "Product",
            name: "Magnasoft Scitex",
            url: "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt",
          item: {
            "@type": "Product",
            name: "Magnasoft Derma NT",
            url: "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/ressisoft-pearl",
          item: {
            "@type": "Product",
            name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
            url: "https://hutaib.org/product/ressisoft-pearl",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz",
          item: {
            "@type": "Product",
            name: "RESSISOFT QUARTZ",
            url: "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
          item: {
            "@type": "Product",
            name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
            url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/polydimethylsiloxane/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/polydimethylsiloxane/#collectionpage",
    url: "https://hutaib.org/product-category/polydimethylsiloxane",
    name: "PDMS Emulsion",
    headline: "Polydimethylsiloxane Supplier in Pakistan for Industrial Use",
    description:
      "Polydimethylsiloxane (PDMS) fluids in Pakistan for industrial applications including lubrication, coating systems, textile processing, and chemical formulations. Hutaib Industrial Solutions supplies PDMS silicone oils in multiple viscosities used in manufacturing and processing industries.",
    keywords: [
      "Polydimethylsiloxane Chemicals",
      "PDMS Chemical",
      "PDMS Silicone Oil",
      "PDMS Fluid",
      "PDMS Curing Agent",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "PDMS Products",
      numberOfItems: 3,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst",
          item: {
            "@type": "Product",
            name: "PDMS Fluid 350 CST",
            url: "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/silicone-oil-pdms-fluid-1000-cst",
          item: {
            "@type": "Product",
            name: "PDMS Fluid 1000CST",
            url: "https://hutaib.org/product/silicone-oil-pdms-fluid-1000-cst",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/high-viscosity-silicone-oil-pdms-fluid-12500-cst",
          item: {
            "@type": "Product",
            name: "PDMS Fluid 12500 CST",
            url: "https://hutaib.org/product/high-viscosity-silicone-oil-pdms-fluid-12500-cst",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/softeners-for-textile/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/softeners-for-textile/#collectionpage",
    url: "https://hutaib.org/product-category/softeners-for-textile",
    name: "Softener",
    headline: "Textile Softeners for Soft, Durable Fabrics in Pakistan",
    description:
      "Textile softener products in Pakistan used for fabric finishing, softness improvement, and handling performance in textile processing. Hutaib Industrial Solutions supplies silicone based and chemical softeners for cotton, polyester, and blended fabrics used in industrial textile applications.",
    keywords: [
      "Textile Softener",
      "Fabrics softeners",
      "Silicone Softeners for Textiles",
      "Textile Softener Chemical",
      "Silicone Fabric Softener",
      "Silicone Softening Agents",
      "Silicone Emulsion For Rubber",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Softener Products",
      numberOfItems: 8,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/boscare-tep-88",
          item: {
            "@type": "Product",
            name: "BosCare TEP-88",
            url: "https://hutaib.org/product/boscare-tep-88",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops",
          item: {
            "@type": "Product",
            name: "Magnasoft OPS",
            url: "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238",
          item: {
            "@type": "Product",
            name: "Magnasoft 238",
            url: "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/multifunctional-softener-magnasoft-88",
          item: {
            "@type": "Product",
            name: "Magnasoft 88",
            url: "https://hutaib.org/product/multifunctional-softener-magnasoft-88",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/eco-friendly-softener-magnasoft-68",
          item: {
            "@type": "Product",
            name: "Magnasoft 68",
            url: "https://hutaib.org/product/eco-friendly-softener-magnasoft-68",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/high-performance-softener-magnasoft-915",
          item: {
            "@type": "Product",
            name: "Magnasoft 915",
            url: "https://hutaib.org/product/high-performance-softener-magnasoft-915",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          url: "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx",
          item: {
            "@type": "Product",
            name: "Magnasoft 588 TX",
            url: "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          url: "https://hutaib.org/product/performance-enhancer-magnasoft-110",
          item: {
            "@type": "Product",
            name: "Magnasoft 110",
            url: "https://hutaib.org/product/performance-enhancer-magnasoft-110",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/surfactants/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://hutaib.org/product-category/surfactants/#collectionpage",
    url: "https://hutaib.org/product-category/surfactants",
    name: "Surfactants",
    headline: "Surfactant Chemicals Supplier in Pakistan for Industry Use",
    description:
      "Surfactant chemicals in Pakistan used in textile processing, emulsification, wetting, cleaning systems, and industrial formulations. Hutaib Industrial Solutions supplies nonionic and silicone based surfactant blends used across textile and chemical manufacturing applications.",
    keywords: [
      "Silicone Surfactants",
      "Surfactant Chemicals",
      "Surfactant for Textile",
      "Surfactant Manufacturer",
      "Surfactant Blends",
      "Nonionic Surfactant",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Surfactants Products",
      numberOfItems: 9,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/bossurf-50",
          item: {
            "@type": "Product",
            name: "BosSurf XL-50",
            url: "https://hutaib.org/product/bossurf-50",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/bossurf-70",
          item: {
            "@type": "Product",
            name: "BosSurf XL-70",
            url: "https://hutaib.org/product/bossurf-70",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/bossurf-xp30",
          item: {
            "@type": "Product",
            name: "BosSurf-XP30",
            url: "https://hutaib.org/product/bossurf-xp30",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/bossurf-xp50",
          item: {
            "@type": "Product",
            name: "BosSurf-XP50",
            url: "https://hutaib.org/product/bossurf-xp50",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/bossurf-to3",
          item: {
            "@type": "Product",
            name: "BosSurf-TO3",
            url: "https://hutaib.org/product/bossurf-to3",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/bossurf-to5",
          item: {
            "@type": "Product",
            name: "BosSurf-TO5",
            url: "https://hutaib.org/product/bossurf-to5",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          url: "https://hutaib.org/product/bossurf-to6",
          item: {
            "@type": "Product",
            name: "BosSurf-TO6",
            url: "https://hutaib.org/product/bossurf-to6",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          url: "https://hutaib.org/product/bossurf-to7",
          item: {
            "@type": "Product",
            name: "BosSurf-TO7",
            url: "https://hutaib.org/product/bossurf-to7",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 9,
          url: "https://hutaib.org/product/bossurf-to8",
          item: {
            "@type": "Product",
            name: "BosSurf-TO8",
            url: "https://hutaib.org/product/bossurf-to8",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },

  "/product-category/other-portfolio/": {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id":
      "https://hutaib.org/product-category/other-portfolio/#collectionpage",
    url: "https://hutaib.org/product-category/other-portfolio",
    name: "Other Portfolio",
    headline: "Chemical Supplier in Pakistan for Industrial & Bulk Needs",
    description:
      "Industrial and bulk chemical products in Pakistan used across coatings, adhesives, construction, water treatment, and manufacturing applications. Hutaib Industrial Solutions supplies a range of chemical raw materials and intermediates for industrial processing and formulation needs.",
    keywords: [
      "Chemical Supplier in Pakistan",
      "Industrial Chemicals",
      "Bulk Chemical Supplier",
      "Chemicals",
    ],
    isPartOf: {
      "@type": "WebSite",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    publisher: {
      "@type": "Organization",
      name: "Hutaib Industrial Solutions",
      url: "https://hutaib.org/",
    },
    mainEntity: {
      "@type": "ItemList",
      name: "Other Portfolio Products",
      numberOfItems: 10,
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          url: "https://hutaib.org/product/hardener-chemical-dcda-dicynadiamine",
          item: {
            "@type": "Product",
            name: "DCDA (Dicynadiamine)",
            url: "https://hutaib.org/product/hardener-chemical-dcda-dicynadiamine",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          url: "https://hutaib.org/product/triethylenetetramine-teta",
          item: {
            "@type": "Product",
            name: "Triethylenetetramine (TETA)",
            url: "https://hutaib.org/product/triethylenetetramine-teta",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          url: "https://hutaib.org/product/diethylenetriamine-deta",
          item: {
            "@type": "Product",
            name: "Diethylenetriamine (DETA)",
            url: "https://hutaib.org/product/diethylenetriamine-deta",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          url: "https://hutaib.org/product/benzyl-alcohol-bp2000",
          item: {
            "@type": "Product",
            name: "Benzyl Alcohol BP2000",
            url: "https://hutaib.org/product/benzyl-alcohol-bp2000",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          url: "https://hutaib.org/product/his-6200h",
          item: {
            "@type": "Product",
            name: "HIS 6200H",
            url: "https://hutaib.org/product/his-6200h",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          url: "https://hutaib.org/product/his-df-406",
          item: {
            "@type": "Product",
            name: "HIS DF 406",
            url: "https://hutaib.org/product/his-df-406",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          url: "https://hutaib.org/product/hydroxypropyl-methyl-cellulose",
          item: {
            "@type": "Product",
            name: "Hydroxypropyl Methyl Cellulose",
            url: "https://hutaib.org/product/hydroxypropyl-methyl-cellulose",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          url: "https://hutaib.org/product/mwr-c",
          item: {
            "@type": "Product",
            name: "MWR-C",
            url: "https://hutaib.org/product/mwr-c",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 9,
          url: "https://hutaib.org/product/polwhitetm-b",
          item: {
            "@type": "Product",
            name: "Polwhite™ B",
            url: "https://hutaib.org/product/polwhitetm-b",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 10,
          url: "https://hutaib.org/product/billions-r-996",
          item: {
            "@type": "Product",
            name: "BILLIONS™ R-996",
            url: "https://hutaib.org/product/billions-r-996",
            brand: {
              "@type": "Brand",
              name: "Hutaib Industrial Solutions",
            },
          },
        },
      ],
    },
  },
};
